import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';


import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as rent_money_bulk_inserts_api from '../Api/rent_money_bulk_inserts_api';



///types
const moment = require('moment')

export interface State {

    rent_money_bulk_insert_list: any;
    rent_money_bulk_insert_search: any;


}
const initialState: State = {

    rent_money_bulk_insert_list: [],
    rent_money_bulk_insert_search: { tatemono_name: "", name: "", user_id: 0, flg: 0 },


}



///action 
const actionCreator = actionCreatorFactory();


export const get_rent_money_bulk_insert_list = actionCreator('GET_RENT_MONEY_BULK_INSERT_LIST');
export const change_rent_money_bulk_insert_list = actionCreator("CHANGE_RENT_MONEY_BULK_INSERT_LIST");

export const change_rent_money_bulk_insert_search = actionCreator<any>("CHANGE_RENT_MONEY_BULK_INSERT_SEARCH");




export const rentMoneyBulkInsertReducer = reducerWithInitialState(initialState)
    .case(change_rent_money_bulk_insert_list, (state, payload) => ({ ...state, rent_money_bulk_insert_list: payload }))
    .case(change_rent_money_bulk_insert_search, (state, payload) => ({ ...state, rent_money_bulk_insert_search: payload }))







// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const rentMoneyBulkInsertSaga = [

    takeEvery('GET_RENT_MONEY_BULK_INSERT_LIST', handle_get_rent_money_bulk_insert_list),



];



function* handle_get_rent_money_bulk_insert_list(action: any) {

    const { payload, error } = yield call(rent_money_bulk_inserts_api.list, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {


        yield put(change_rent_money_bulk_insert_list(payload))




    } else {
        alert(error)

    }



}


